import gCard from "@/components/g-card/g-card.vue";
import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";

const name = 'PDFDetalhesTitulo'

export default {
    name,

    components: { 
    "g-card": gCard,
    "g-button": gButton,
    "g-form": gForm
    }, 

    props: { 
        tituloSelecionado: {
            type: String,
            default: ''
          },
    },

    mounted() { 

        this.GetDadosTitulo()
    },

    updated() { },

    data() {
        return { 
            empresaSelecionada: this.$store.state.empresaSelecionadaNome,
            infoTitulo: [],
            clienteId: null,
            unidadeId: null,
        }
    },

    methods: { 
        GetDadosTitulo() {
            this.$isLoading(true)
            this.axios({
              method: 'get',
              url: process.env.VUE_APP_WEB_API + `Documento/GetDetalhesTitulo/${this.tituloSelecionado}`,
            })
            .then((response) => {
                this.infoTitulo = response.data.data
                this.clienteId = response.data.data.clienteId
                this.unidadeId = response.data.data.unidadeId
                this.executaTermino();
            })
            .finally(()=> {
                this.$isLoading(false)
              })
        },
        executaTermino(){
            this.$emit('termino')
          },
    },

    computed: { }, 
};